import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useDeleteAllScenarioClassConversions = () => {
  const { mutate: deleteScenarioClassConversions, isPending } = useAppMutation(
    [QueryKey.DELETE_SCENARIO_CLASS_CONVERSION],
    {
      mutationFn: ({ scenarioId }: { scenarioId: string }) =>
        ApiService.delete({
          endpoint: BackendRoute.SCENARIOS,
          routePath: [scenarioId, 'scenario-class-conversions', 'remove-all'],
        }),
    },
  );
  return { deleteScenarioClassConversions, isPending };
};
